// Packages
import styled from "styled-components";

import tw from "twin.macro";

export const StyledHeader = styled.div.attrs({
  className: "StyledHeader",
})`
  ${(props) => {
    return `
      ${
        props.backgroundColor
          ? `background-color:${props.backgroundColor}`
          : ` background-color: #6e6e6e`
      };
      ${props.colorContrast ? `color:${props.colorContrast}` : ` color: white`}
    `;
  }}
`;

export const StyledBrand = styled.div.attrs({
  className: "StyledBrand",
})`
  .font-customBold {
    font-size: 0.75rem;
  }
  ${(props) => {
    return `
      ${
        props.backgroundColor
          ? `background-color:${props.backgroundColor}`
          : ` background-color: #6e6e6e`
      };
      ${props.colorContrast ? `color:${props.colorContrast}` : ` color: white`}
    `;
  }}
`;

export const StyledImageBrand = styled.img.attrs({
  className: "StyledImageBrand",
})`
  ${tw` block mx-auto`}
  width: auto;
  max-height: 1.5rem;
`;
export const StyledNavbar = styled.div.attrs({
  className: "StyledNavbar",
})`
  height: 0%;
  width: 100%;
  position: fixed;
  z-index: 1;
  top: 64px;
  left: 0;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
`;
